import React from 'react';

import RolePermissionsSectionForm from 'roles/components/RolePermissionsSectionForm';

const RolePermissionsForm = ({
  allSections = [],
  bySection = {},
  handleCheckPermission,
  handleClickPermissionRow,
  handleCheckSection,
  t = (k) => k,
  values,
}) => {
  return (
    <div className="col-12">
      {allSections.map((s) => (
        <RolePermissionsSectionForm
          handleCheckPermission={handleCheckPermission}
          handleClickPermissionRow={handleClickPermissionRow}
          handleCheckSection={handleCheckSection}
          key={s}
          section={s}
          permissions={bySection[s]}
          t={t}
          values={values}
        />
      ))}
    </div>
  );
};

export default RolePermissionsForm;



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/components/RolePermissionsForm.js